import config from 'config/appConfig';
import init from './fetchInit';
import indicator from './fetchIndicator';
import indicatorMeta from './fetchIndicatorMetaFromWP';
import geography from './fetchGeography';
import landingMeta from './fetchLandingMeta';

export function apiUrl(win = window) {
  switch (win.location.hostname) {
    case 'h7.prb.org':
    case '34.233.175.150':
    case 'prb.alley.ws':
      return config.apiUrl.staging;
    case 'prb-2017.alley.dev':
    case 'prb-2017.alley.http':
    case 'nodeproxy.alley.dev':
    case 'nodeproxy.alley.http':
    case 'localhost':
      return config.apiUrl.local;
    default:
      return config.apiUrl.production;
  }
}

export function wpUrl(win = window) {
  switch (win.location.hostname) {
    case 'h7.prb.org':
    case '34.233.175.150':
      return config.wpUrl.staging;
    case 'prb.alley.ws':
      return config.wpUrl.development;
    case 'prb-2017.alley.dev':
    case 'prb-2017.alley.http':
    case 'nodeproxy.alley.dev':
    case 'nodeproxy.alley.http':
    case 'localhost':
      return config.wpUrl.local;
    default:
      return config.wpUrl.production;
  }
}

export default {
  init,
  geography,
  indicator,
  indicatorMeta,
  landingMeta,
};



// WEBPACK FOOTER //
// ./app/services/fetch/index.js